import React, { FunctionComponent } from 'react'
import { Features } from '../../model'
import { useFlag } from '@afterpaytouch/feature'
import { Theme, useIsTheme, Text, Heading } from '@afterpaytouch/core'
import styles from './style.module.css'
import { useTranslation } from '../../utils/convergence'
import { Illustration, ILLUSTRATIONS } from '../Illustration'

interface CashMaintenanceModeTextFlag {
  heading: string
  description: string
}

export const MaintenanceModeContent: FunctionComponent = () => {
  const isAPTheme = useIsTheme(Theme.AP)
  const { t } = useTranslation()
  const maintenanceTestNameSpace = 'maintenance'
  const maintenanceModeText = useFlag<string>(Features.MAINTENANCE_MODE_TEXT, '')
  const cashMaintenanceModeText = useFlag<CashMaintenanceModeTextFlag>(Features.CASH_MAINTENANCE_MODE_TEXT, {
    heading: '',
    description: '',
  })

  const cashMaintenanceModeTextWithBrandName = `${t('common:brandName')} ${cashMaintenanceModeText?.heading}`

  return (
    <>
      <div className={styles.maintenanceImage}>
        <Illustration name={ILLUSTRATIONS.ConeDog} width={327} height={250} testId='maintenance-mode-image' />
      </div>
      {isAPTheme ? (
        <Text testNameSpace={maintenanceTestNameSpace}>{maintenanceModeText}</Text>
      ) : (
        <>
          <Heading size='XL' testNameSpace={maintenanceTestNameSpace}>
            {cashMaintenanceModeTextWithBrandName}
          </Heading>
          <div className={styles.descriptionWrapper}>
            <Text testNameSpace={maintenanceTestNameSpace}>{cashMaintenanceModeText?.description}</Text>
          </div>
        </>
      )}
    </>
  )
}
